import React from 'react';
import { AsyncStorage } from 'react-native';

import { stateStorage } from './StateStorage';

export default class MemberStorage {
  setMember(member, token, callback) {
    AsyncStorage.setItem('MEMBER', JSON.stringify(member), () => {
      callback();
    });
  }

  getMember(callback) {
    AsyncStorage.getItem('MEMBER', (err, result) => {
      if (result) {
        let member;
        try {
          member = JSON.parse(result);
        }
        catch (error) {
          console.log('Failed to parse MEMBER, skipping it', error);
          callback(undefined, undefined);
          return;
        }
        AsyncStorage.getItem('TOKEN', (err, result) => {
          if (result) {
            callback(member, "");
          }
          else {
            callback(member, undefined);
          }
        });
      }
      else {
        callback(undefined, undefined);
      }
    });
  }

  removeMember(callback) {
    stateStorage.removeState();
    localStorage.setItem('preventGoBack', 'true');

    AsyncStorage.removeItem('MEMBER', (err) => {
      callback();
    });
  }
}

export const memberStorage = new MemberStorage();
